module.exports = __webpack_public_path__ + "static/media/Artboard21.2ee9e59b.png";